import * as React from 'react';
import { useRef } from 'react'
import 'react-multi-carousel/lib/styles.css';
import { useEffect, useState } from "react";
import { Box, Card, CardActionArea, Input } from '@mui/material';
import { gold, white } from '../../../../getLPTheme';


const icons: Record<any, { icon: string, width: number }> = {
  club: {
    icon: 'https://club-vip-media.s3.us-east-1.amazonaws.com/icons-svg/club.svg',
    width: 100,
  },
  hotel: {
    icon: 'https://club-vip-media.s3.us-east-1.amazonaws.com/icons-svg/hotelcama.svg',
    width: 100,
  },
  comercio: {
    icon: 'https://club-vip-media.s3.us-east-1.amazonaws.com/icons-svg/proshop.svg',
    width: 100,
  },
  restaurant: {
    icon: 'https://club-vip-media.s3.us-east-1.amazonaws.com/icons-svg/restaurant.svg',
    width: 100,
  },
  };

export default function MapTest({items}) {

    let [mapa, setMap] = useState<google.maps.Map>()
    const latitud = -34.974928056546716;
    const longitud = -58.456266430586346;
    const position = {lat: latitud, lng:longitud} // Club de Campo el candil
    // const center: google.maps.LatLngLiteral = {lat: latitud, lng: longitud};
    const ref = useRef<HTMLDivElement>()
    const placeInput = document.getElementById("place-input") as HTMLInputElement
    let autocomplete:any;
    

    function widthScreen () {
        const widthScreen = document.body.clientWidth
        if (widthScreen < 500) { let widthMap = "300px"
           return widthMap
        } else {
          let widthMap = "800px"
          return widthMap
        }
      }
    
      function heightScreen () {
        const widthScreen = document.body.clientWidth
        if (widthScreen < 500) { let heightMap = "500px"
           return heightMap
        } else {
          let heightMap = "700px"
          return heightMap
        }
      }

    const InitMaptest = async () => {

      useEffect(()=>{
        if(ref.current && !mapa){
          setMap(new google.maps.Map(document.getElementById('map') as HTMLElement, {
            center: position,
            zoom: 2,
            mapId: 'b43fd4b4ec044b83 ',
          }))
        }
      }, [mapa])


      const marcadores = items

      console.log("marcadores",marcadores)

      const {AdvancedMarkerElement}  = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;

      const markers = marcadores.map((position, i) => {
        let markerSvg = document.createElement('img');
        markerSvg.src = icons[marcadores[i].typeMarker].icon
        markerSvg.width = 70;

        let positionLat = Number.parseFloat(marcadores[i].coordinates.slice(0,items[i].coordinates.indexOf(",")))
        let positionLng = Number.parseFloat(marcadores[i].coordinates.slice(((items[i].coordinates.indexOf(","))+1),items[i].coordinates.length))
        const myLatLng = { lat: positionLat, lng: positionLng };


        let collisionBehavior = google.maps.CollisionBehavior.REQUIRED;  // Si se superponen no desaparecen


        const marker = new google.maps.marker.AdvancedMarkerElement({
          map: mapa,
          position: myLatLng,
          title: marcadores[i].pointId,
          content: markerSvg,
          collisionBehavior: collisionBehavior,
        });

        if (mapa) {
          mapa.addListener('zoom_changed', () => {
            const zoom = mapa.getZoom();
            if (zoom) {
                // Only show each marker above a certain zoom level.
                marker.map = zoom > 8 ? mapa : null;
            }
          });
        }

        marker.addListener("click", () => {
          let infowindow = new google.maps.InfoWindow({content: `<div><b>${marcadores[i].name}</b>, ${marcadores[i].address}</div><br><div>${marcadores[i].country}, ${marcadores[i].state}, ${marcadores[i].locate}</div> <div><a href="https://maps.google.com/maps?ll=${positionLat},${positionLng}&z=15" target="_blank">Ver en Google Maps</a></div>`,ariaLabel: marcadores[i].name, disableAutoPan: true,})
          infowindow.open({
            anchor: marker,
            map: mapa,
          });        
        });
        return marker;
      });

    };


    const searchGoogleMap = () => {

      autocomplete = new google.maps.places.Autocomplete(placeInput);
      autocomplete.addListener("place_changed",() => {
        const place = autocomplete.getPlace();

        try { 
          mapa.setCenter(place.geometry.location)
        } catch (e) {
          return
        }

        // if (place.geometry.location == 'undefined') {
        //   mapa.setCenter(position);
        // } else {
        //   mapa.setCenter(place.geometry.location);
        // }
        // console.log("place geometry", place.geometry.location)
        
        mapa.setZoom(13);
      })
    }

    InitMaptest();
    searchGoogleMap();
    
    return (
      <>
        <Box sx={{ width:"100%", display: "flex",  flexDirection: 'row', alignItems: "Center", justifyContent: "center" }}>
          <Box  sx={{ width:{xs:"80%", sm:"50%", md:"50%"}, display: "flex",  flexDirection: 'row', alignItems: "Center", justifyContent: "center" }}>
            <Box>
              <Card sx={{p:1, transition: "0.2s","&:hover": {transform: "scale(1.02)",},}}>
                  <Box id="map" ref={ref as any} style={{ width: widthScreen(), minHeight:heightScreen()}}></Box>
              </Card>
            </Box>
          </Box>
        </Box>
      </>
      )
  }